<script>
  import Button from '@components/Button.svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  import Cookie from 'js-cookie';
  import { goto } from '$app/navigation';

  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';

  export let mobile = false;
  export let text = 'This is a demo account. Sign up for free.';
  export let buttonText = 'Sign up';
  export let style = '';

  let currentUser = getCurrentUserStore('default');
  let showCreateAccountModal = false;
</script>

<style style="text/scss" lang="scss">
  .demo-notification {
    background: linear-gradient(90.42deg, #fcf0e3 0.07%, #eae4ff 98.94%);
    border-radius: 20px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
    padding-left: 20px;
    padding-right: 20px;
  }

  .mobile {
    width: calc(100% - 60px) !important;
    height: 70px;
    position: absolute;
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>

{#if currentUser && (currentUser.copied_demo_user_id || (currentUser.email && currentUser.email.includes('@demo.benable.com')))}
  {#if showCreateAccountModal}
    <div>
      <CreateAccountModal
        eventDetails={{ trigger_event: 'signup_button' }}
        msgStyle="font-size: 20px;"
        mobile={mobile}
        successCallback={() => {
          goto(`/discover`);
        }}
        beforeDataSend={(data) => {
          data['landing_page'] = Cookie.get('landing-page');
          data['sign_up_source'] = {
            source: 'demo',
          };
          return data;
        }}
        namePlaceholder={'Full Name'}
        showPassword={true}
        msg="Create your Benable account"
        buttonText="Create account"
        bind:showModal={showCreateAccountModal}
        inviteFlow={true} />
    </div>
  {/if}

  <div class="demo-notification" style={style} class:mobile={mobile}>
    <span class="demo-text" style="font-size: 15px; line-height: 24px; color: #5A5372">
      {text}
    </span>
    <span style="margin-left: {mobile ? '20px' : '41px'}; flex-shrink: 0;" class="demo-btn">
      <Button
        text={buttonText}
        style="{mobile ? 'width: 80px;' : 'width: 131px;'} height: 48px; margin-top: 0px; margin-bottom: 0px;
        padding-top: 0px; padding-bottom: 3px; display: flex; justify-content:
        center; align-items: center;"
        on:click={() => {
          showCreateAccountModal = true;
        }} />
    </span>
  </div>
  <div style="height: 72px; {mobile ? 'margin-top: 20px' : ''}" />
{/if}
